module.exports = __webpack_public_path__ + "img/404.c9c9610d.gif";